var render = function render(){var _vm=this,_c=_vm._self._c;return _c('report-stock',{attrs:{"title":"Bodega Móvil - Stock de Bodega Móvil","mobileWarehousesStock":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }